import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 23 25",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M22.077 21.211 18 17.134a9.648 9.648 0 1 0-2.073 1.751l4.234 4.238a1.335 1.335 0 0 0 1.889 0 1.332 1.332 0 0 0 .027-1.912ZM3.861 10.707a6.945 6.945 0 1 1 6.957 6.957 6.965 6.965 0 0 1-6.957-6.957Z" }, null, -1)
  ]))]))
}
export default { render: render }